import { render, staticRenderFns } from "./PlanosConta.vue?vue&type=template&id=2d957d5a&scoped=true&"
import script from "./planosConta.js?vue&type=script&lang=js&"
export * from "./planosConta.js?vue&type=script&lang=js&"
import style0 from "./PlanosConta.vue?vue&type=style&index=0&id=2d957d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d957d5a",
  null
  
)

export default component.exports